import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

const STEPS = [
  {
    num: '01',
    icon: 'ri-whatsapp-line',
    title: 'Contato via WhatsApp',
    desc: 'Entre em contato imediatamente pelo WhatsApp. Atendimento disponível 24 horas para casos urgentes.',
  },
  {
    num: '02',
    icon: 'ri-file-list-3-line',
    title: 'Avaliação do Caso',
    desc: 'Análise detalhada da situação, documentos e circunstâncias para entender todos os aspectos jurídicos.',
  },
  {
    num: '03',
    icon: 'ri-lightbulb-line',
    title: 'Definição da Estratégia',
    desc: 'Elaboração de uma estratégia de defesa personalizada, técnica e alinhada aos seus objetivos.',
  },
  {
    num: '04',
    icon: 'ri-shield-check-line',
    title: 'Acompanhamento Completo',
    desc: 'Presença em todas as etapas: delegacia, audiências, tribunais e recursos, até o desfecho final.',
  },
];

export default function HowItWorksSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="como-funciona" ref={sectionRef} className="bg-white py-16 md:py-28 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="font-cinzel font-bold text-navy text-3xl md:text-5xl lg:text-6xl leading-tight">
              Como <em className="font-cinzel italic text-green-cta">Funciona</em>
            </h2>
            <p className="font-montserrat font-light text-grey text-base md:text-lg mt-3 max-w-lg">
              Quatro passos claros para sua defesa criminal especializada.
            </p>
          </div>
          <span className="self-start md:self-auto font-montserrat font-medium text-white text-xs bg-navy px-4 py-1.5 rounded-full">
            Processo
          </span>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {STEPS.map((step, i) => (
            <div
              key={i}
              className={`relative bg-bg-card rounded-2xl md:rounded-3xl p-6 md:p-8 transition-all duration-500 hover:-translate-y-1 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Connector line (desktop) */}
              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-3 w-6 h-px bg-grey/20" />
              )}
              <span className="font-cinzel font-bold text-navy text-3xl md:text-4xl opacity-30">
                {step.num}
              </span>
              <div className="mt-4 w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center">
                <i className={`${step.icon} text-grey text-xl w-full h-full flex items-center justify-center`} />
              </div>
              <h3 className="font-cinzel font-bold text-navy text-lg mt-4">
                {step.title}
              </h3>
              <p className="font-montserrat font-light text-grey text-sm mt-2 leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 md:mt-14 text-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-cta text-navy font-montserrat font-semibold text-sm px-6 py-3 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap"
          >
            <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
            Falar com o Advogado no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}